export { EloBaseIcon } from './base-icon'
export { EloBaseIconProps } from './types'
